<template>
    <div class="salesroom">
        <div class="search">
            <div class="search-box flex-row">
                <img class="searchImg" :src="search" alt="" >
                <input class="searchVal" placeholder="请输入关键字搜索" v-model="value" type="text">
            </div>
        </div>
        <div class="maps">
            <baidu-map class="map" :center="center" :zoom="15" :keyboard="true" :scroll-wheel-zoom="true" :double-click-zoom="true">
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                <bm-control></bm-control>
            </baidu-map>
        </div>
        <ul class="salesItem">
            <li class="item">
                <div class="content">
                    <p>北京大钟寺二店</p>
                    <p>营业时间：08:00-19:00</p>
                    <p>283km|北京市海淀区被三环路23号2层</p>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import search from '@/assets/img/search.png';
import contents from '@/components/content';
import { getWxJsSignature } from '@/api/index';
import WX from 'weixin-jsapi';
export default {
    data(){
        return {
            search,
            value:'',
            keyword: '',
            // 百度地图
            centerDialogVisible: false,
            keyword: "",
            center: { lng: 116.404, lat: 39.915 }, //经纬度
            indexAdd: 0,
            editAddressIndex: "",
            wxJsdk: null
        }
    },
    mounted(){
            getWxJsSignature({url: 'https://www.finehome100.com/'}).then(res => {
                WX.config({
                　　　　debug: true, // 开启调试模式,
                　　　　appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                　　　　timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                　　　　nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                　　　　signature: res.data.signature,// 必填，签名，见附录1
                　　　　jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                　　});
                // console.log(this.wxJsdk.ready())
                // location.href.split('#')[0]
                this.getWX();
            }).catch(error => {
                alert(4);
                console.log(error)
            });
    },
    methods:{
        /**
         * 获取wx地理位置
         * @func
         */
        getWX(){
            console.log(WX);
                WX.ready(function () {
                    WX.getLocation({
                        type: 'wgs84',
                        success: function (res) {
                            alert(res);
                            alert(1);
                        },
                        cancel: function (res) {
                            alert('用户拒绝授权获取地理位置');
                            alert(2)
                        }
                    });
                });
                WX.error(function (res) {
                    alert(3)
                    console.log(res)
                });
        }
    }
}
</script>
<style lang="scss" scoped>
.salesroom{
    .search{
        height: 82px;
        background: $ffff;
        .search-box{
            width:670px;
            height:60px;
            background:rgba(255,255,255,1);
            border:2px solid rgba(229,229,229,1);
            border-radius:10px;
            margin:18px 0 0 39px;
            align-items: center;
            .searchImg{
                margin-left: 17px;
                width: 24px;
                height: 24px;
            }
            .searchVal{
                margin-left: 18px;
                width: 600px;
                height: 100%;
            }
        }
    }
  .map {
    width: 100%;
    height: 650px;
    .map_input{
      width:350px;
      height:30px;
    }
    .map_searchinfo{
      width:350px;
      max-height:450px;
      overflow:auto;
    }
  }
  .item{
      border-bottom: 1px solid #f6f6f6; 
      padding: 0 20px 20px 20px;
      .content{
          p{
              margin-top:20px;
          }
      }
  }
}
</style>


